import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import RentImages from './RentImages'
import Loading from '../../components/Loading'
import { Parser } from 'html-to-react'
import { store } from '../../components/HOC/State'
import { axiosInstance } from '../../const/axiosInstance'
import styles from './rent.module.css'

export default function RentItem() {
    const [el, setEl] = useState({})
    const [loading, setLoading] = useState(false)

    const  {selectedLang} = useContext(store)
    
    const htmlParser = new Parser()

    const {id} = useParams()

    useEffect(() =>{
        (async() => {
            setLoading(true)
            const res = await axiosInstance.get(`/use/rent/${id}`)
            if(res.data.status){
                setEl(res.data.data)
            }else{
                setEl({})
            }
            setLoading(false)
        })()
      }, [])
  

  return (
    <div className={styles['rent-item-main']}>
        {loading ? <Loading width={200}/> :
        <div className={styles['rent-item-div']}>
            <RentImages images={el.images}/>
            <div className={styles['rent-item-information']}>
                <div className={styles['other-info']}>
                    <div>
                        {htmlParser.parse(el[`${selectedLang}information`]?.
                                replaceAll(`iframe width="auto" height="auto"`, `iframe width="${window.innerWidth > 900 ? 0.28*window.innerWidth : 0.6*window.innerWidth}" height="${window.innerWidth > 900 ? 0.28*window.innerWidth/1.6 : 0.6*window.innerWidth/1.6}" allowfullscreen`).
                                replaceAll("alt=\"undefined\" style=\"height: auto;width: auto\"/>", `alt="undefined" "height="auto" width="${window.innerWidth > 900 ? 0.28*window.innerWidth : 0.6*window.innerWidth}"/>`))}
                    </div>
                </div>
            </div>
        </div>}
    </div>
  )
}
